import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DropdownItem } from '../models/dropdownItem';
import { MainFilterItem } from '../models/mainFilterItem';

@Component({
  selector: 'app-new-rankings-main-filter-items',
  templateUrl: './rankings-main-filter-items.component.html',
  styleUrls: [
    './rankings-main-filter-items.component.scss',
    '../rankings-responsive.scss'
  ]
})
export class RankingsMainFilterItemsComponent implements OnInit {
  @Input()
  currentMainFilterItems: Array<MainFilterItem>;

  @Input()
  selectedGroup: string;

  @Output()
  selectMainFilterClick: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {}

  selectMainFilter(mainFilterItem: MainFilterItem, option: DropdownItem) {
    this.selectMainFilterClick.emit({
      mainFilterItem,
      option
    });
  }

  selectedMainFilterItemClick(mainFilterItem: MainFilterItem, event) {
    // if (mainFilterItem.options.length < 2) {
    //   event.stopPropagation();
    //   mainFilterItem.showTooltip = true;
    //   setTimeout(() => {
    //     mainFilterItem.showTooltip = false;
    //   }, 2000);
    // }
  }

  onSearchEnter(mainFilterItem: MainFilterItem) {
    this.onSearchChange(mainFilterItem);

    const visibleOptions = mainFilterItem.options.filter(
      option => !option.hidden
    );

    if (visibleOptions.length === 1) {
      this.selectMainFilter(mainFilterItem, visibleOptions[0]);

      const dropdownToggle = document.querySelector(
        `#dropdownMenuButton[aria-expanded="true"]`
      ) as HTMLElement;
      if (dropdownToggle) {
        dropdownToggle.click();
      }
    }
  }

  onSearchChange(mainFilterItem: MainFilterItem) {
    let found = false;

    mainFilterItem.options.forEach(option => {
      option.hidden = !(
        !mainFilterItem.searchText ||
        (mainFilterItem.searchText &&
          option.label
            .toLowerCase()
            .indexOf(mainFilterItem.searchText.toLowerCase()) >= 0)
      );

      if (!option.hidden) {
        found = true;
      }
    });

    if (!found) {
      mainFilterItem.showNoResults = true;
    } else {
      mainFilterItem.showNoResults = false;
    }
  }
}
